import { render, staticRenderFns } from "./EmailProviderTariffs.vue?vue&type=template&id=50ae7b19&"
import script from "./EmailProviderTariffs.vue?vue&type=script&lang=ts&"
export * from "./EmailProviderTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports